import { render, staticRenderFns } from "./ContainerEditor.vue?vue&type=template&id=6b446974&scoped=true"
import script from "./ContainerEditor.vue?vue&type=script&lang=js"
export * from "./ContainerEditor.vue?vue&type=script&lang=js"
import style0 from "./ContainerEditor.vue?vue&type=style&index=0&id=6b446974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b446974",
  null
  
)

export default component.exports